var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.995 12.005a1 1 0 0 0 .884.993l.117.007h11.58l-3.29 3.294a1 1 0 0 0-.081 1.32l.083.094a1 1 0 0 0 1.32.082l.094-.083 4.913-4.923a.998.998 0 0 0 .38-.784l-.002-.074-.014-.111-.012-.052a.978.978 0 0 0-.183-.387l-.084-.094-5.019-5a1 1 0 0 0-1.495 1.322l.084.094 3.314 3.301H4.996a1 1 0 0 0-1 1z",
    fill: "#1B3DF2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArrowRight);
export default __webpack_public_path__ + "static/media/icons-arrow-right.51f64d70912fe80a8a5287c10d6faccb.svg";
export { ForwardRef as ReactComponent };